import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useState } from "react";
import { useFieldArray, useForm, useWatch } from "react-hook-form";
import { EDIT_SALE } from "../apollo/mutations";
import { LIST_PRODUCTS, SALE_DETAIL } from "../apollo/queries";
import {
  getSelectedStoreDetails,
  payloadValidator,
} from "../utils/helperFunctions";
import closeModal from "../common/closeModal";
import { showErrorToast } from "../utils";
// import { showErrorToast } from "../utils";

const useEditSale = ({ refetch, rowData, editKey }) => {

  const [selectedBrand, setSelectedBrand] = useState(null)
  const [manipulatedProducts, setManipulatedProducts] = useState([]);
  // const defaultValues = {
  //     id: rowData?.id,
  //     customer_id: rowData?.customer?.id,
  //     warehouse_id: rowData?.warehouse?.id,
  //     status: rowData?.status,
  //     sale_tax: rowData?.sale_tax,
  //     discount: rowData?.discount,
  //     shipping: rowData?.shipping,
  //     description: rowData?.description,
  //     sale_products: [],
  // };
  const [fetchSaleDetails, { data: data }] = useLazyQuery(SALE_DETAIL);
  // const { data } = useQuery(SALE_DETAIL, {
  //   variables: {
  //     getSaleId: rowData?.id,
  //   },
  //   skip: !rowData?.id,
  //   fetchPolicy: "network-only",
  // });

  useEffect(() => {
    if (editKey) {
      fetchSaleDetails({
        variables: {
          getSaleId: rowData?.id,
        },
      });
    }
  }, [editKey]);

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      id: "",
      customer_id: "",
      warehouse_id: "",
      status: "",
      sale_tax: "",
      discount: "",
      shipping: "",
      description: "",
      sale_products: [],
    },
  });

  const {
    fields: products,
    append: appendProducts,
    remove: removeProducts,
  } = useFieldArray({
    control,
    name: "sale_products",
  });

  const sale_products = useWatch({
    control,
    name: "sale_products",
  });

  const warehouse_id = useWatch({
    control,
    name: "warehouse_id",
  });

  const [fetchProducts, { data: productsData }] = useLazyQuery(LIST_PRODUCTS);

  useEffect(() => {
    if (warehouse_id) {
      fetchProducts({
        variables: {
          storeId: getSelectedStoreDetails("id"),
          warehouseId: warehouse_id,
          brandId: selectedBrand?.value || null,
          customerId: rowData.customer?.id
        },
      });
    }
  }, [warehouse_id, selectedBrand]);

  useEffect(() => {
    if (productsData?.listProduct) {
      // Manipulate the product data here
      const transformedProducts = productsData.listProduct.map((product) => ({
        value: product.id,
        label: product.name,
        images: product.images,
        price: product.price,
      }));
      setManipulatedProducts(transformedProducts);
    }
  }, [productsData]);

  useEffect(() => {
    console.log("rowData && data?.getSale");
    if (rowData && data?.getSale) {
      console.log("Inside");
      const updatedDefaults = {
        id: rowData.id,
        customer_id: rowData.customer?.id,
        warehouse_id: rowData.warehouse?.id,
        status: rowData.status,
        sale_tax: rowData.sale_tax,
        discount: rowData.discount,
        shipping: rowData.shipping,
        description: rowData.description,
        sale_date: data.getSale.sale_date,
        sale_products: data.getSale.sale_items?.map((item) => ({
          id: item?.id,
          product_id: item?.product?.id,
          productName: item?.product?.name,
          price: item?.price,
          quantity: item?.quantity,
          images: item?.product?.images?.[0],
        })),
      };
      reset(updatedDefaults);
    }
  }, [rowData, data, editKey]);

  // useEffect(() => {
  //     if (rowData && data?.getSale) {
  //         console.log("data", data?.getSale)
  //         defaultValues.sale_date = data?.getSale?.sale_date;
  //         defaultValues.sale_products = data?.getSale?.sale_items?.map(
  //             (item) => ({
  //                 id: item?.id,
  //                 productName: item?.product?.name,
  //                 quantity: item?.quantity,
  //                 price: item?.price,
  //                 product_id: item?.product?.id,
  //                 images: item?.product?.images?.[0],
  //             })
  //         );
  //         reset(defaultValues);
  //     }
  // }, [rowData, data]);

  const [submit] = useMutation(EDIT_SALE);

  const onEditQuotation = async (data) => {
    try {
      const invalidProduct = data.sale_products.find(
        (item) =>
          item.price == "" || item.price == "0" || item.price === undefined
      );

      if (invalidProduct) {
        showErrorToast("Please enter a valid product price");
        return;
      }

      const invalidQty = data.sale_products.find(
        (item) =>
          item.quantity == "" ||
          item.quantity == "0" ||
          item.quantity === undefined
      );

      if (invalidQty) {
        showErrorToast("Please enter a valid product quantity");
        return;
      }
      delete data.product_id;
      const sale_products = data.sale_products.map(
        ({ id = null, product_id, quantity, price }) => ({
          id,
          product_id,
          quantity: parseInt(quantity),
          price: parseFloat(price),
        })
      );
      delete data.sale_products;
      delete data.customer_id;
      delete data.warehouse_id;
      delete data.status;
      const payload = {
        ...data,
        sale_products,
        sale_tax: parseFloat(data?.sale_tax),
        discount: parseFloat(data?.discount),
        shipping: parseFloat(data?.shipping),
      };
      console.log("payload Data", payload);
      await submit(payloadValidator(payload));
      reset({
        defaultValues: {
          id: "",
          customer_id: "",
          warehouse_id: "",
          status: "",
          sale_tax: "",
          discount: "",
          shipping: "",
          description: "",
          sale_products: [],
        },
      });
      refetch();
      closeModal("edit-sales-new");
    } catch (error) {
      console.log("Mutation error:", error.message);
    }
  };

  const onCancel = () => {
    setSelectedBrand(null)
    setManipulatedProducts([])
    reset({
      defaultValues: {
        id: "",
        customer_id: "",
        warehouse_id: "",
        status: "",
        sale_tax: "",
        discount: "",
        shipping: "",
        description: "",
        sale_products: [],
      },
    });
    closeModal("edit-sales-new");
  };

  return {
    values: {
      control,
      errors,
      products,
      sale_products,
      productsData: manipulatedProducts,
      selectedBrand
    },
    setValue,
    getValues,
    refetch,
    functions: {
      onSubmit: handleSubmit(onEditQuotation),
      onCancel,
      appendProducts,
      removeProducts,
      setSelectedBrand
    },
  };
};

export default useEditSale;
